import { httpPost, httpGet, httpPostFile, httpDownload } from "../../../../utils/api.utils";
import { convertDateStringToDateFormat, convertToFormatTimeZoneDate, getTextBeforeDash } from "../../../../utils/helpers.utils";
import { actions } from "react-redux-form";
import Moment from 'moment';
import { batch } from "react-redux";
import { DEFAULT_TABLE_RESULT_MODEL, DEFAULT_TABLE_RESULT_RECHARGE_INVENTORY_DROPDOWN_MODEL, RECHARGE_INVENTORY_TYPE } from "../../../../constants/external-constants";
import { rechargeInventoryDetailsModel,
         otcInformationModel,
         mappingInformationModel,
         additionalInformationModel,
         locationInformationModel,
         circuitInformationModel,
         mrcInformationModel,
         equipmentInformationModel,
         getRechargeInventoryDropdownList,
         setRechargeInventoryError,
         getMrcRechargeDropdown,
         getRechargeViaDummyInvoiceDropdown,
         getRechargeInventoryDetails,
         getMappingInformationList,
         addMappingInformation,
         updateMappingInformation,
         deleteMappingInformation,
         getRechargeInventoryComments,
         getRechargeInventoryLineItems,
         setRechargeLineItemsPageSize,
         setRechargeLineItemsColSearchStr,
         setSortRechargeLineItems,
         setResetRechargeLineItems,
         setRechargingEmployeeLoading,
         setRequestorOptions,
         setEndUserOptions,
         setRechargingPersonOptions,
         setVendorLoading,
         setVendorOption,
         setLocationLoading,
         setLocationOption,
         setCircuitLoading,
         setCircuitOption,
         getCostCodeList,
         resetCostCodeList,
         insertToRechargeComment,
         resetRechargeComments
 } from "../../../../constants/model-reducers/external/recharge/recharge-inventory/recharge-inventory-details.settings";

export const rechargeInventoryDetailsInitialState = rechargeInventoryDetailsModel;
export const mappingInformationInitialState = mappingInformationModel;
export const additionalInformationInitialState = additionalInformationModel;
export const locationInformationInitialState = locationInformationModel;
export const otcInformationInitialState = otcInformationModel;
export const circuitInformationInitialState = circuitInformationModel;
export const mrcInformationInitialState = mrcInformationModel;
export const equipmentInformationInitialState = equipmentInformationModel;

const defaultState = () => ({
    isRechargeInventoryError: false,
    isRechargeInventoryDropDownListLoaded: false,
    mrcRechargeDropdown: [],
    rechargeViaDummyInvoiceDropdown: [],
    rechargeInventoryDetailsDropDownList: DEFAULT_TABLE_RESULT_RECHARGE_INVENTORY_DROPDOWN_MODEL,
    rechargeInventoryData: [],
    fetchRechargeInventoryDetails: true,
    mappingInformationList:{
        datatable:[]
    },
    rechargeInventoryComments: [],
    rechargeLineItems: [],
    rechargeCostCode: [],
    isRechargeInventoryLoaded: false,
    isRechargeLineItemLoaded: false,
    isEmployeeLoading: false,
    requestorOptions: [],
    requestorPage: 1,
    hasMoreRequestor: true,
    rechargingPersonOptions: [],
    rechargingPersonPage: 1,
    hasMoreRechargingPerson: true,
    endUserOptions: [],
    endUserPage: 1,
    hasMoreEndUser: true,
    isVendorLoading: false,
    vendorOptions: [],
    vendorPage: 1,
    hasMoreVendor: true,
    isLocationLoading: false,
    locationOptions: [],
    locationPage: 1,
    hasMoreLocation: true,
    isCircuitLoading: false,
    circuitOptions: [],
    circuitPage: 1,
    hasMoreCircuit: true,
    circuitLimitRender: 1,
    isCostCodeListLoaded: false,
    rechargeComments: [],
    hasMoreRechargeComments: true,
    pageCommentsIndex: 1,
});
const initialState = defaultState();

export const RechargeInventoryDetailsActions = {
    getRechargeInventoryDropdownList: (rechargeInventoryId = 0) => async (dispatch, state) => {

        var res = await httpGet('external/recharge/getRechargeInventoryDropdownList/' + rechargeInventoryId);

        if (res != null) {
            dispatch({
                type: getRechargeInventoryDropdownList,
                isRechargeInventoryDropDownListLoaded: true,
                rechargeInventoryDetailsDropDownList: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_RECHARGE_INVENTORY_DROPDOWN_MODEL,
            });
        }
        else {
            dispatch({
                type: setRechargeInventoryError,
                isRechargeInventoryDropDownListLoaded: false,
                isRechargeInventoryError: true
            });
        }
    }
    , getRequestorOption: (pageIndex = 1, searchString = '') => async (dispatch) => {
        var requestor = await getRechargingEmployees(pageIndex, searchString, dispatch);

        dispatch({
            type: setRequestorOptions,
            payload: {
                requestorOption: requestor.employeeData
                , requestorPage: pageIndex
            }
        })
    }
    , getRechargingPersonOption: (pageIndex = 1, searchString = '') => async (dispatch) => {
        var rechargingPerson = await getRechargingEmployees(pageIndex, searchString, dispatch);

        dispatch({
            type: setRechargingPersonOptions,
            payload: {
                rechargingPersonOption: rechargingPerson.employeeData
                , rechargingPersonpage: pageIndex
            }
        })
    }
    , getEndUserOption: (pageIndex = 1, searchString = '') => async (dispatch) => {
        var endUser = await getRechargingEmployees(pageIndex, searchString, dispatch);

        dispatch({
            type: setEndUserOptions,
            payload: {
                endUserOption: endUser.employeeData
                , endUserpage: pageIndex
            }
        })
    }
    , getVendorOption: (pageIndex = 1, searchString = '') => async (dispatch) => {
        const pageSize = 15;
        dispatch({
            type: setVendorLoading
            , payload: true
        })
        try {
            let url = `external/recharge/getRechargingVendors/${pageIndex}/${pageSize}`;

            if (searchString) {
                url += `/${encodeURIComponent(searchString)}`;
            }
            var res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: setVendorOption
                    , vendorOption: res
                    , vendorPage: pageIndex
                })

                return res;
            }
            else {
                return null;
            }
        }
        catch (error) {
            return null;
        }
        finally {
            dispatch({
                type: setVendorLoading
                , payload: false
            })
        }
    }
    , getLocationOption: (pageIndex = 1, searchString = '') => async (dispatch) => {
        const pageSize = 15;

        dispatch({
            type: setLocationLoading
            , payload: true
        })
        try {
            let url = `external/recharge/getRechargingLocations/${pageIndex}/${pageSize}`;
            if (searchString) {
                url += `/${encodeURIComponent(searchString)}`;
            }
            var res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: setLocationOption
                    , locationOption: res
                    , locationPage: pageIndex
                })

                return res;
            }
            else {
                return null;
            }
        }
        catch (error) {
            return null;
        }
        finally {
            dispatch({
                type: setLocationLoading
                , payload: false
            })
        }
    }
    , getCircuitOption: (pageIndex = 1, searchString = '',) => async (dispatch, state) => {
        const { circuitLimitRender, rechargeInventoryData } = state().rechargeInventoryDetails
        const rechargeInventoryId = rechargeInventoryData?.data?.RechargeInventoryID ?? 0;
        const pageSize = 15;

        dispatch({
            type: setCircuitLoading
            , payload: true
        })
        try {
            let url = `external/recharge/getRechargingCircuits/${pageIndex}/${pageSize}/${rechargeInventoryId}`;
            if (searchString) {
                url += `/${encodeURIComponent(searchString)}`;
            }
            var res = await httpGet(url);

            if (res != null) {
                dispatch({
                    type: setCircuitOption
                    , circuitOption: res
                    , circuitPage: pageIndex
                })
                return res;
            }
            else {
                return null;
            }
        }
        catch (error) {
            return null;
        }
        finally {
            dispatch({
                type: setCircuitLoading
                , payload: false
            })
        }
    },
    
    getCostCodeList: (page=1, searchString='') => async (dispatch, getState) => {
    
            if (getState().isCostCodeListLoaded) return;
    
             const pageSize = 15;
    
            dispatch({ 
               type: getCostCodeList,
               isCostCodeListLoaded: false 
           });
                    
            var url = `external/recharge/getRechargeInventoryCostCenter/${page}/${pageSize}`;
    
            if(searchString) {
                url += `/${encodeURIComponent(getTextBeforeDash(searchString))}`;
            }
            
            var res = await httpGet(url);
    
            if (res != null) {
                dispatch({
                    type: getCostCodeList,
                    isCostCodeListLoaded: true,
                    rechargeCostCode: res?.costCodes?.length > 0 ? res?.costCodes : [],
                    hasMoreData: res.hasMoreData,
                    page: page,
                });
            }
            else {
                dispatch({
                    type: getCostCodeList,
                    isCostCodeListLoaded: false,
                    rechargeCostCode: [],
                    isError: true
                });
            }
    },

    getSelectedCostCode: (costCodeId) => async (dispatch) => {
            var res = await httpGet('external/recharge/getSelectedCostCode' + '/' + costCodeId);
            return res;
    }
    ,getCircuitDetails: (circuitId) => async (dispatch, state) => {
        var res = await httpGet('external/recharge/getCircuitDetails/' + circuitId)

        if (res != null) {
            dispatch(actions.change('rechargeInventoryDetailsForm.circuitInformation.circuitId', res.CircuitId));
            dispatch(actions.change('rechargeInventoryDetailsForm.circuitInformation.circuitCode', res.CircuitCode));
            dispatch(actions.change('rechargeInventoryDetailsForm.circuitInformation.circuitTypeId', res.CircuitTypeId));
            dispatch(actions.change('rechargeInventoryDetailsForm.circuitInformation.circuitTypeName', res.CircuitTypeName));
            dispatch(actions.change('rechargeInventoryDetailsForm.circuitInformation.installDate', res.InstallDate ? convertDateStringToDateFormat(res.InstallDate) : ''));
            dispatch(actions.change('rechargeInventoryDetailsForm.additionalInformation.accountNumber', res.AccountNumber));
            dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.vendorId', res.VendorDetailId));
            dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.vendorName', res.VendorName));
            dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.endUserId', res.EndUserID));
            dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.endUserEmail', res.EndUserEmail));
            dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.requestorId', res.RequestorID));
            dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.requestorEmail', res.RequestorEmail));
        }
        else {
        dispatch({
            type: setRechargeInventoryError,
            isRechargeInventoryError: true
            });
        }
    }

    ,getMrcRechargeDropdown: () => async (dispatch,state) => {
        var res = await httpGet('external/recharge/getMrcRechargeDropdown')

        dispatch({
            type: getMrcRechargeDropdown,
            mrcRechargeDropdown: res
        });
    }
    ,getRechargeViaDummyInvoiceDropdown: () => async (dispatch) => {
        var res = await httpGet('external/recharge/getRechargeViaDummyInvoiceDropdown')

        dispatch({
            type: getRechargeViaDummyInvoiceDropdown,
            rechargeViaDummyInvoiceDropdown: res
        });
    }
    ,setRechargeInventoryType: (rechargeInventoryTypeId) => async(dispatch) => {
        if (parseInt(rechargeInventoryTypeId) === parseInt(RECHARGE_INVENTORY_TYPE["OTC"].id)){
            dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType', RECHARGE_INVENTORY_TYPE["OTC"].label));
        }
        else if (parseInt(rechargeInventoryTypeId) === parseInt(RECHARGE_INVENTORY_TYPE["Equipment"].id)){
            dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType', RECHARGE_INVENTORY_TYPE["Equipment"].label));
        }
        else if (parseInt(rechargeInventoryTypeId) === parseInt(RECHARGE_INVENTORY_TYPE["Circuit"].id)) {
            dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType', RECHARGE_INVENTORY_TYPE["Circuit"].label));
        }
        else {
            dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType', RECHARGE_INVENTORY_TYPE["Circuit"].label));
        }
    }

    ,getLocationDetails: (locationId) => async (dispatch) => {
        var res = await httpGet('external/recharge/getLocationDetails/' + locationId);

        if (res != null) {
            dispatch(actions.change('rechargeInventoryDetailsForm.locationInformation.locationId', locationId));
            dispatch(actions.change('rechargeInventoryDetailsForm.locationInformation.locationAddress', res.LocationAddress));
            dispatch(actions.change('rechargeInventoryDetailsForm.locationInformation.locationCountryCode', res.LocationCountryCode));
            dispatch(actions.change('rechargeInventoryDetailsForm.locationInformation.locationState', res.LocationState));
            dispatch(actions.change('rechargeInventoryDetailsForm.locationInformation.locationCode', res.LocationCode));
        }
        else {
            dispatch({
                type: setRechargeInventoryError,
                isRechargeInventoryError: true
            });
        }
    }

    ,setOtcNumber: (otcNumber) => async (dispatch) => {
        if(otcNumber){
            dispatch(actions.change('rechargeInventoryDetailsForm.otcInformation.otcNumber', otcNumber));
        }
    }

    ,setEquipmentNumber: (equipmentNumber) => async (dispatch) => {
        if(equipmentNumber){
            dispatch(actions.change('rechargeInventoryDetailsForm.equipmentInformation.equipmentNumber', equipmentNumber));
        }
    }

    ,setFormDefaultDetails: (rechargeInventoryType) => async(dispatch, state) => {
        const { rechargeInventoryDetailsDropDownList, mrcRechargeDropdown, rechargeViaDummyInvoiceDropdown } = state().rechargeInventoryDetails
        
        dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.operationalStatusId', rechargeInventoryDetailsDropDownList?.OperationalStatus[0].Key));
         
        if(rechargeInventoryType === RECHARGE_INVENTORY_TYPE["OTC"].label){
            dispatch(actions.change('rechargeInventoryDetailsForm.otcInformation.otcTypeId', rechargeInventoryDetailsDropDownList?.OTCType[0].Key));
        }
        if(rechargeInventoryType === RECHARGE_INVENTORY_TYPE["Equipment"].label){
            dispatch(actions.change('rechargeInventoryDetailsForm.equipmentInformation.equipmentTypeId', rechargeInventoryDetailsDropDownList?.EquipmentType[0].Key));
            dispatch(actions.change('rechargeInventoryDetailsForm.rechargeInventory.operationalStatusId', rechargeInventoryDetailsDropDownList?.OperationalStatus[0].Key));
        }
        if (rechargeInventoryType === RECHARGE_INVENTORY_TYPE["Circuit"].label) {
            dispatch(actions.change('rechargeInventoryDetailsForm.mrcInformation.mrcRecharge', mrcRechargeDropdown?.data[0].Key.toString()));
            dispatch(actions.change('rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice', rechargeViaDummyInvoiceDropdown?.data[0].Key.toString()));
        }

        dispatch(actions.change("rechargeInventoryDetailsForm.mappingInformation.MappingStatusID", rechargeInventoryDetailsDropDownList?.MappingStatus[0].Key));
    }

    ,saveRechargeInventory: (rechargeInventoryId, validate) => async (dispatch, state) => {
        const { rechargeInventory, additionalInformation, locationInformation, otcInformation, circuitInformation, mrcInformation, equipmentInformation } = state().form.rechargeInventoryDetailsForm
        const { mappingInformationList } = state().rechargeInventoryDetails

            var rechargeInventoryType;
            if(rechargeInventory.rechargeInventoryType === RECHARGE_INVENTORY_TYPE["OTC"].label){
                rechargeInventoryType = RECHARGE_INVENTORY_TYPE["OTC"].id;
            }
            else if(rechargeInventory.rechargeInventoryType === RECHARGE_INVENTORY_TYPE["Equipment"].label){
                rechargeInventoryType = RECHARGE_INVENTORY_TYPE["Equipment"].id;
            }
            else {
                rechargeInventoryType = RECHARGE_INVENTORY_TYPE["Circuit"].id;
            }

        var initialHardwareCategory = circuitInformation?.hardwareCategoryId === 0 ? 1 : circuitInformation?.hardwareCategoryId;

        try {
            const mrcDefaultValue = mrcInformation.mrcRechargeAmount === null || mrcInformation.mrcRecharge === "false" ? "0.00000" : mrcInformation.mrcRechargeAmount;
            const DLIAmountDefaultValue = mrcInformation.dummyLineItemAmount === null || mrcInformation.rechargeViaDummyInvoice === "false" ? "0.00000" : mrcInformation.dummyLineItemAmount;

                var detailsForm = {
                    //Common Fields
                    RechargeInventoryID: rechargeInventoryId
                    , OperationalStatusID: rechargeInventory.operationalStatusId
                    , RechargingInventoryTypeID: rechargeInventoryType
                    , VendorID: rechargeInventory.vendorId
                    , EndUserID: parseInt(rechargeInventoryType) !== parseInt(RECHARGE_INVENTORY_TYPE["Equipment"].id)  ? rechargeInventory.endUserId : equipmentInformation.equipmentEndUserId
                    , RequestorID: parseInt(rechargeInventoryType) !== parseInt(RECHARGE_INVENTORY_TYPE["Equipment"].id)  ? rechargeInventory.requestorId : equipmentInformation.equipmentRequestorId
                    , RechargePersonID: rechargeInventory.rechargePersonId
                    , RechargeQuantity: rechargeInventory.rechargeQuantity
                    , ServiceInstanceID: rechargeInventory.serviceInstanceId ?? null
                    , OutputRecordID: rechargeInventory.outputRecordId

                    //OTC Fields
                    , OTCNumber: otcInformation.otcNumber
                    , OTCDdi: otcInformation.otcDDI
                    , OTCTypeID: otcInformation.otcTypeId
                    , ActivationDate: otcInformation.activationDate ? Moment(otcInformation.activationDate).format('YYYY-MM-DD') : null

                    //Circuit Fields
                    , CircuitId: circuitInformation.circuitId
                    , CircuitCode: circuitInformation.circuitCode
                    , OrderTypeId: circuitInformation.orderTypeId
                    , CircuitDDI: circuitInformation.circuitDDI
                    , HardwareCategoryId: initialHardwareCategory

                    //EquipmentFields
                    ,EquipmentNumber: equipmentInformation.equipmentNumber
                    ,EquipmentDdi: equipmentInformation.equipmentDDI
                    ,EquipmentTypeId: equipmentInformation.equipmentTypeId
                    , DeliveryDate: equipmentInformation.deliveryDate ? Moment(equipmentInformation.deliveryDate).format('YYYY-MM-DD') : null

                    // For Both Circuit and Equipment Fields
                    , InstallDate: parseInt(rechargeInventoryType) === parseInt(RECHARGE_INVENTORY_TYPE["Equipment"].id)
                        ? (equipmentInformation.installDate ? Moment(equipmentInformation.installDate).format('YYYY-MM-DD') : null)
                        : (circuitInformation.installDate ? Moment(circuitInformation.installDate).format('YYYY-MM-DD') : null)
                }

                var additionalInformationForm = {
                    // Common Fields
                    Requisition: additionalInformation.requisition
                    , BasketRequisitionNumber: additionalInformation.basketRequisitionNumber
                    , BasketNumber: additionalInformation.basketNumber
                    , BasketItemPosition: additionalInformation.basketItemPosition
                    , CustomerTag: additionalInformation.customerTag
                    
                }

                var locationInformationForm = {
                    LocationID: locationInformation.locationId
                }

                var mrcInformationForm = {
                    MrcRecharge: mrcInformation.mrcRecharge
                    , MrcRechargeAmount: mrcDefaultValue
                    , RechargeViaDummyInvoice: mrcInformation.rechargeViaDummyInvoice
                    , DummyLineItemAmount: DLIAmountDefaultValue
                    , DummyInvoiceDate: mrcInformation.dummyInvoiceDate ? Moment(mrcInformation.dummyInvoiceDate).format('YYYY-MM-DD') : null
                    , DummyInvoiceDueDate: mrcInformation.dummyInvoiceDate ? Moment(mrcInformation.dummyInvoiceDate).format('YYYY-MM-DD') : null
                }

                var mappingInformationData = mappingInformationList.datatable[0].dataItem.length > 0 ? mappingInformationList.datatable[0].dataItem : [];

                var formData = {
                    ...detailsForm
                    , additionalInformation: {
                        ...additionalInformationForm
                    }
                    , locationInformation: {
                        ...locationInformationForm
                    }
                    , mrcInformation: {
                        ...mrcInformationForm
                    },
                    mappingInformation: mappingInformationData
                }

                var validateValue = validate === undefined ? 0 : validate;
                
                var result = await httpPost(`external/recharge/saveRechargeInventory/${rechargeInventoryId}/${validateValue}`, formData);
            }
            catch (e) {
                return e;
            }
            return result;
    }

    , getRechargeInventory: (rechargeInventoryId) => async (dispatch) => {
        dispatch({
            type: getRechargeInventoryDetails,
            data: {
                fetching: true
            }
        });

        var res = await httpGet(`external/recharge/getRechargeInventoryDetails/${rechargeInventoryId}`);
        var data = res.data;

        if (data) {
            batch(() => {

                if (parseInt(data.RechargingInventoryTypeID) === parseInt(RECHARGE_INVENTORY_TYPE["OTC"].id)){
                    dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType', RECHARGE_INVENTORY_TYPE["OTC"].label));
                }
                else if (parseInt(data.RechargingInventoryTypeID) === parseInt(RECHARGE_INVENTORY_TYPE["Equipment"].id)) {
                    dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType', RECHARGE_INVENTORY_TYPE["Equipment"].label));
                    dispatch(actions.load('rechargeInventoryDetailsForm.equipmentInformation.equipmentNumber', data.EquipmentNumber));
                    dispatch(actions.load('rechargeInventoryDetailsForm.equipmentInformation.equipmentDDI', data.EquipmentDDI));
                    dispatch(actions.load('rechargeInventoryDetailsForm.equipmentInformation.equipmentTypeId', data.EquipmentTypeId));
                    dispatch(actions.load('rechargeInventoryDetailsForm.equipmentInformation.deliveryDate', convertDateStringToDateFormat(data.DeliveryDate, false)))
                    dispatch(actions.load('rechargeInventoryDetailsForm.equipmentInformation.installDate', convertDateStringToDateFormat(data.InstallDate, false)))
                    dispatch(actions.load('rechargeInventoryDetailsForm.equipmentInformation.equipmentEndUserId', data.EndUserID))
                    dispatch(actions.load('rechargeInventoryDetailsForm.equipmentInformation.equipmentRequestorId', data.RequestorID))
                }
                else {
                    dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.rechargeInventoryType', RECHARGE_INVENTORY_TYPE["Circuit"].label));
                }
                //Common fields
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.rechargingInventoryId', data.RechargeInventoryID));
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.operationalStatusId', data.OperationalStatusID));
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.vendorId', data.VendorID));
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.vendorName', data.VendorName));
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.endUserId', data.EndUserID));
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.endUserEmail', data.EndUserEmail));
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.requestorId', data.RequestorID));
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.requestorEmail', data.RequestorEmail));
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.rechargePersonId', data.RechargePersonID));
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.serviceInstanceId', data.ServiceInstanceID));
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.outputRecordId', data.OutputRecordID));
                dispatch(actions.load('rechargeInventoryDetailsForm.rechargeInventory.rechargeQuantity', data.RechargeQuantityString));

                //OTC
                dispatch(actions.load('rechargeInventoryDetailsForm.otcInformation.otcNumber', data.OTCNumber));
                dispatch(actions.load('rechargeInventoryDetailsForm.otcInformation.otcDDI', data.OTCDdi));
                dispatch(actions.load('rechargeInventoryDetailsForm.otcInformation.otcTypeId', data.OTCTypeID));
                dispatch(actions.load('rechargeInventoryDetailsForm.otcInformation.activationDate', convertDateStringToDateFormat(data.ActivationDate, false)));

                //Circuit
                dispatch(actions.load('rechargeInventoryDetailsForm.circuitInformation.circuitId', data.CircuitID));
                dispatch(actions.load('rechargeInventoryDetailsForm.circuitInformation.circuitCode', data.CircuitCode));
                dispatch(actions.load('rechargeInventoryDetailsForm.circuitInformation.circuitDDI', data.CircuitDDI));
                dispatch(actions.load('rechargeInventoryDetailsForm.circuitInformation.circuitTypeId', data.CircuitTypeId));
                dispatch(actions.load('rechargeInventoryDetailsForm.circuitInformation.circuitTypeName', data.CircuitTypeName));
                dispatch(actions.load('rechargeInventoryDetailsForm.circuitInformation.orderTypeId', data.OrderTypeId));
                dispatch(actions.load('rechargeInventoryDetailsForm.circuitInformation.installDate', data.InstallDate ? convertDateStringToDateFormat(data.InstallDate, false) : null));
                dispatch(actions.load('rechargeInventoryDetailsForm.circuitInformation.hardwareCategoryId', data.HardwareCategoryID));

                //Location
                dispatch(actions.load('rechargeInventoryDetailsForm.locationInformation.locationId', data.LocationID));
                dispatch(actions.load('rechargeInventoryDetailsForm.locationInformation.locationAddress', data.LocationAddress));
                dispatch(actions.load('rechargeInventoryDetailsForm.locationInformation.locationCountryCode', data.LocationCountryCode));
                dispatch(actions.load('rechargeInventoryDetailsForm.locationInformation.locationState', data.LocationState));
                dispatch(actions.load('rechargeInventoryDetailsForm.locationInformation.locationCode', data.LocationCode));

                //Additional Information
                dispatch(actions.load('rechargeInventoryDetailsForm.additionalInformation.requisition', data.Requisition));
                dispatch(actions.load('rechargeInventoryDetailsForm.additionalInformation.basketRequisitionNumber', data.BasketRequisitionNumber));
                dispatch(actions.load('rechargeInventoryDetailsForm.additionalInformation.customerTag', data.CustomerTag));
                dispatch(actions.load('rechargeInventoryDetailsForm.additionalInformation.financeAccountId', data.FinanceAccountId));
                dispatch(actions.load('rechargeInventoryDetailsForm.additionalInformation.accountNumber', data.AccountNumber));
                dispatch(actions.load('rechargeInventoryDetailsForm.additionalInformation.basketNumber', data.BasketNumber));
                dispatch(actions.load('rechargeInventoryDetailsForm.additionalInformation.basketItemPosition', data.BasketItemPosition));

                //Mrc Information
                dispatch(actions.load('rechargeInventoryDetailsForm.mrcInformation.mrcRecharge', data.MrcRecharge === false ? "false" : true));
                dispatch(actions.load('rechargeInventoryDetailsForm.mrcInformation.mrcRechargeAmount', data.MrcRechargeAmountString));
                dispatch(actions.load('rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice', data.RechargeViaDummyInvoice === false ? "false" : true));
                dispatch(actions.load('rechargeInventoryDetailsForm.mrcInformation.dummyLineItemAmount', data.DummyLineItemAmountString));
                dispatch(actions.load('rechargeInventoryDetailsForm.mrcInformation.dummyInvoiceDate', data.DummyInvoiceDate ? convertDateStringToDateFormat(data.DummyInvoiceDate, false) : null));
                dispatch(actions.load('rechargeInventoryDetailsForm.mrcInformation.dummyInvoiceDueDate', data.DummyInvoiceDueDate ? convertDateStringToDateFormat(data.DummyInvoiceDueDate, false) : null));

                dispatch({
                    type: getRechargeInventoryDetails,
                    data: {
                        fetching: false,
                        data: data
                    }
                });
            });

            return data;
        }
    }

    ,resetRechargeInventoryDetailForm: () => (dispatch) => {
        dispatch(actions.reset('rechargeInventoryDetailsForm'));
        dispatch(actions.reset('rechargeInventoryDetailsForm.rechargeInventory'));
        dispatch(actions.reset('rechargeInventoryDetailsForm.mappingInformation'));
        dispatch(actions.reset('rechargeInventoryDetailsForm.additionalInformation'));
        dispatch(actions.reset('rechargeInventoryDetailsForm.locationInformation'));
        dispatch(actions.reset('rechargeInventoryDetailsForm.otcInformation'));
        dispatch(actions.reset('rechargeInventoryDetailsForm.circuitInformation'));
        dispatch(actions.reset('rechargeInventoryDetailsForm.mrcInformation'));
        dispatch(actions.reset('rechargeInventoryDetailsForm.equipmentInformation'));
    }

    ,addMappingInformationItem: () => (dispatch, state) => {
        const { VatGroup, PriceCalculation, MappingStatus } = state().rechargeInventoryDetails.rechargeInventoryDetailsDropDownList;
        const { datatable } = state().rechargeInventoryDetails.mappingInformationList;
        const { mappingInformation } = state().form.rechargeInventoryDetailsForm;
        const { rechargeCostCode } = state().rechargeInventoryDetails;
    
        var dataItem = datatable[0].dataItem;
        var HeaderItem = datatable[0].HeaderItem;
        
        var costCenterValue = rechargeCostCode.filter(r => parseInt(r.Key) === parseInt(mappingInformation.CostCenterID));
        var vatGroupValue = VatGroup.filter(r => parseInt(r.Key) === parseInt(mappingInformation.VatGroupID));
        var priceCalculationValue = PriceCalculation.filter(r => parseInt(r.Key) === parseInt(mappingInformation.PriceCalculationID));
        var mappingStatusValue = MappingStatus.filter(r => parseInt(r.Key) === 1)
    
        var newDataItem = [
            ...dataItem,
            {
                ...mappingInformation,
                ID: -1,
                CostCenterType: costCenterValue.length > 0 ? costCenterValue[0].Value : null,
                VatGroupType: vatGroupValue.length > 0 ? vatGroupValue[0].Value : null,
                PriceCalculationType: priceCalculationValue.length > 0 ? priceCalculationValue[0].Value : null,
                MappingStatus: mappingStatusValue[0].Value
            }
        ];
    
        var newDataTable = [{
            dataItem: newDataItem,
            HeaderItem: HeaderItem,
        }];
    
        dispatch({
            type: addMappingInformation,
            datatable: newDataTable
        });
    },

    getMappingInformationList: (rechargeInventoryId) => async (dispatch, state) => {

        var data = await httpGet('external/recharge/getMappingInformationList/' + rechargeInventoryId);
    
        dispatch({
            type: getMappingInformationList,
            datatable: data.datatable,
        });
    },
    updateMappingInformationItem: () => (dispatch, state) => {
        const { VatGroup = [], CostCenter = [], PriceCalculation = [], MappingStatus = [] } = state().rechargeInventoryDetails.rechargeInventoryDetailsDropDownList;    
        const { datatable } = state().rechargeInventoryDetails.mappingInformationList;
        const { mappingInformation } = state().form.rechargeInventoryDetailsForm;
    
        var dataItem = datatable[0].dataItem;
        var HeaderItem = datatable[0].HeaderItem;
    
        var indexItem = mappingInformation.ID;

        var costCenterValue = CostCenter?.filter(r => parseInt(r.Key) === parseInt(mappingInformation.CostCenterID));
        var vatGroupValue = VatGroup?.filter(r => parseInt(r.Key) === parseInt(mappingInformation.VatGroupID));
        var priceCalculationValue = PriceCalculation?.filter(r => parseInt(r.Key) === parseInt(mappingInformation.PriceCalculationID));
        var mappingStatusValue = MappingStatus?.filter(r => parseInt(r.Key) === 1)
    
        dataItem[indexItem] = {
            ...mappingInformation,
            ID: dataItem[indexItem].ID,
            CostCenterType: costCenterValue?.length > 0 ? costCenterValue[0]?.Value : null,
            VatGroupType: vatGroupValue?.length > 0 ? vatGroupValue[0]?.Value : null,
            PriceCalculationType: priceCalculationValue.length > 0 ? priceCalculationValue[0].Value : null,
            MappingStatus: mappingStatusValue[0].Value,
            MappingStatusID: mappingStatusValue[0].Key
        };
    
        var newDataTable = [{
            dataItem: dataItem,
            HeaderItem: HeaderItem,
        }];
    
        dispatch({
            type: updateMappingInformation,
            datatable: newDataTable
        });
    },

    refreshRechargeInventory: (rechargeInventoryId, validate) => async (dispatch, getState) => {
        const { mappingInformationList } = getState().rechargeInventoryDetails;

        try {
            const datatable = mappingInformationList?.datatable ?? [];
            const mappingInformationData = datatable.length > 0 ? datatable[0]?.dataItem ?? [] : [];

            const formData = {
                mappingInformation: mappingInformationData
            };

            const validateValue = validate ?? 0;

            const result = await httpPost(`external/recharge/refreshRechargeInventory/${rechargeInventoryId}/${validateValue}`, formData);

            if (result?.mapResult?.success === false) {
                const { propertyName, mappedstatus } = result.mapResult;

                if (propertyName === "DebitorNumber" && (mappedstatus === 3 || mappedstatus === 4)) {
                    dispatch(actions.setErrors("rechargeInventoryDetailsForm.mappingInformation.DebitorNumber", true));
                } else if (propertyName === "ArticleNumber" && (mappedstatus === 3 || mappedstatus === 4)) {
                    dispatch(actions.setErrors("rechargeInventoryDetailsForm.mappingInformation.ArticleNumber", true));
                }
            }

            return result;
        } catch (e) {
            return e;
        }
    },

    resetMappingInformationForm: () => (dispatch, state) => {
    
        const formData = {
            ...mappingInformationModel
        };
    
        dispatch(actions.change("rechargeInventoryDetailsForm.mappingInformation", formData));
        dispatch({
            type: resetCostCodeList
        });
    },
    
    viewMappingInformation: (index) => async (dispatch, state) => {
        const { datatable } = state().rechargeInventoryDetails.mappingInformationList;

        const data = await datatable[0].dataItem[0];
    
        const dataItem = {
            ...data,
            ID: index,
        };
    
        dispatch(actions.reset("rechargeInventoryDetailsForm.mappingInformation"));
        dispatch(actions.change("rechargeInventoryDetailsForm.mappingInformation", dataItem));

        return dataItem;
    
    },
    deleteMappingInformationItem: (index) => (dispatch, state) => {
        const { datatable } = state().rechargeInventoryDetails.mappingInformationList;
    
        var dataItem = datatable[0].dataItem;
        var HeaderItem = datatable[0].HeaderItem;
    
        var newDataItem = [...dataItem];
        newDataItem.splice(index, 1);
    
        var newDataTable = [{
            dataItem: newDataItem,
            HeaderItem: HeaderItem,
        }];
    
        dispatch({
            type: deleteMappingInformation,
            datatable: newDataTable,
        });
    },
   postRechargeComments: (rechargeInventoryId, filename, fileData, comment) => async (dispatch, state) => {

        // const { pageCommentsIndex } = state().recharge;
        // const addIndex = pageCommentsIndex + 1;

        var formData = new FormData();
        var user = JSON.parse(sessionStorage.getItem('User'));

        if (fileData && fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment?.toString() ?? "");
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')));
        formData.append("RechargingInventoryID", rechargeInventoryId);

        var res = await httpPostFile('external/recharge/setRechargeComments', formData);

        if (res != null) {
            dispatch({
                type: insertToRechargeComment, // 👈 similar to insertToContractComment
                rechargeComments: res?.rechargeComments,
                isRechargeInventoryLoaded: true,
                isRechargeInventoryError: false
            });
        } else {
            dispatch({
                type: setRechargeInventoryError,
                isRechargeInventoryError: true,
                isRechargeInventoryLoaded: false
            });
        }
    },

    resetRechargeComments: () => (dispatch) => {
        dispatch({
            type: resetRechargeComments,
        })
    },

    getRechargeLineItems: (rechargeCircuitId, pageIndex = 0) => async (dispatch, state) =>{

        const {Pagination, Headers} = state().rechargeInventoryDetails.rechargeLineItems;
    
        var data = {
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes? Pagination.PageSizes : [10, 20, 30] 
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            CircuitId: rechargeCircuitId,
            Headers: {
                ...Headers
            },
            SortedColumnName: "",
            IsSortAscending: false,
            TableFilterList: [],
            ApplyFilter: false,
            StatusFilter: [],
            ApplyStatusFilter: 0,
            ApplyTabFilter: 0,
        };
        const response = await httpPost('external/recharge/getRechargingCircuitLineItems', data);

        if (response != null) {
            dispatch({
                type: getRechargeInventoryLineItems,
                rechargeLineItems: response,
                isRechargeLineItemLoaded: false,
                isRechargeInventoryError: false
            });
        } else {
            dispatch({
                type: setRechargeInventoryError,
                isRechargeInventoryError: true,
                isRechargeInventoryLoaded: false
            });
   
        }
    },

    resizeRechargeLineItemsPage: (pageSize) => async (dispatch, state) => {
            dispatch({
                type: setRechargeLineItemsPageSize,
                pageSize: parseInt(pageSize),
            });
    },

    setRechargeLineItemsColSearchStr: (event, key) => async (dispatch, state) => {
            var val = event.target.value;
            const { rechargeLineItems } = state().rechargeInventoryDetails;
            var invoiceLineItemsItemsUpd = {
                ...rechargeLineItems,
                "Headers": {
                    ...rechargeLineItems.Headers,
                    [key]: {
    
                        ...rechargeLineItems.Headers[key],
                        searchString: val
                    }
                }
            }
    
            dispatch({
                type: setRechargeLineItemsColSearchStr,
                data: invoiceLineItemsItemsUpd,
                isRechargeLineItemLoaded: true
            });
    },

    sortRechargeLineItems: (columnClicked, isSortedAsc, CircuitId) => async (dispatch, state) => {
            const { Headers, Pagination, Data, SortedColumnName, IsSortAscending } = state().rechargeInventoryDetails.rechargeLineItems;
            const { rechargeLineItems } = state().rechargeInventoryDetails;
            var formData = {
                InvoiceID: 0,
                PageFilter: {
                    PageIndex: Pagination.PageNumber !== undefined ? Pagination.PageNumber : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes? Pagination.PageSizes : [10, 20, 30] 
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: sessionStorage.getItem('UserID'),
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                CircuitId: CircuitId,
                Headers: {
                    ...Headers
                },
                SortedColumnName: columnClicked,
                IsSortAscending: isSortedAsc,
                TableFilterList: [],
            };
            const response = await httpPost('external/recharge/getRechargingCircuitLineItems', formData);
            dispatch({
                type: setSortRechargeLineItems,
                rechargeLineItems: response,
                isRechargeLineItemLoaded: true,
                isRechargeLineItemError: false
            });
        },

        extractCircuitLineItems: (columnClicked, isSortedAsc = false, CircuitId) => async (dispatch, state) => {
                const { Headers, Pagination, SortedColumnName, IsSortAscending } = state().rechargeInventoryDetails.rechargeLineItems;
                const dealName = sessionStorage.getItem('DealName');
                const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;
        
                const formattedTimeZoneDate = convertToFormatTimeZoneDate(
                    new Date(),
                    activeDateFormat?.Name || "YYYY-MM-DD",
                    activeTimeZoneOffset?.UtcOffset || 0)
                    .replace(/[<>:"/\|?*]/g, '-');
                var filename = `ATEM ${dealName} Recharging Circuit Line Items Extract – ${formattedTimeZoneDate}`;

                var formData = {
                    InvoiceID: 0,
                    PageFilter: {
                        PageIndex: Pagination.PageNumber !== undefined ? Pagination.PageNumber : 0,
                        PageSize: Pagination.PerPage,
                        PageSizes: Pagination.PageSizes? Pagination.PageSizes : [10, 20, 30] 
                    },
                    Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                    UserId: sessionStorage.getItem('UserID'),
                    EmployeeId: sessionStorage.getItem('EmployeeID'),
                    CircuitId: CircuitId,
                    Headers: {
                        ...Headers
                    },
                    SortedColumnName: columnClicked,
                    IsSortAscending: isSortedAsc,
                    TableFilterList: [],
                    FileName: filename
                };
                httpDownload('external/recharge/getRechargeCircuitLineItemsExtractItems', formData)
                    .then(function (response) {
                        return response.blob();
                    })
                    .then(function (blob) {
                        let downloadUrl = window.URL.createObjectURL(blob);
                        //Hide Loading
                        let a = document.createElement('a');
                        if (window.navigator.msSaveOrOpenBlob) {
                            window.navigator.msSaveOrOpenBlob(blob, filename);
                        } else if (typeof a.download === 'undefined') {
                            window.location = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename + '.xlsx';
                            document.body.appendChild(a);
                            a.click();
                        }
                    });
        },

    resetInvoiceLineItems: () => (dispatch, state) => {
            dispatch({
                type: setResetRechargeLineItems
            })
    },

    getRechargeComments: (rechargeInventoryID, pageIndex = 1, pageSize = 5, bypassPagination = true) => async (dispatch, state) => {
        const existingComments = state().rechargeInventoryDetails?.rechargeComments || [];
        console.log("State keys:", Object.keys(state()));
        console.log("Full Redux state:", state());
        const lastCommentId = existingComments.length > 0
            ? existingComments[existingComments.length - 1].CommentID
            : null;

        const url = `external/recharge/getRechargeComments/${pageIndex}/${pageSize}?rechargeInventoryID=${rechargeInventoryID}`
            + (lastCommentId ? `&lastCommentId=${lastCommentId}` : "");

        var res = await httpGet(url);

        if (res != null) {
            dispatch({
                type: getRechargeInventoryComments,
                rechargeComments: res.rechargeComments,
                isRechargeInventoryLoaded: true,
                isRechargeInventoryError: false,
                pageIndex: pageIndex,
                hasMoreData: res.hasMoreData
            });
        } else {
            dispatch({
                type: setRechargeInventoryError,
                isRechargeInventoryError: true,
                isRechargeInventoryLoaded: false
            });
        }
    },


    deleteRechargeComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID")
        var res = await httpPost('external/recharge/rechargeDeleteComment/' + commentId + '/' + userId);
    
        if (res == null) {
            dispatch({
                type: setRechargeInventoryError,
                isRechargeInventoryError: true,
                isRechargeInventoryLoaded: false
            });
   
        }
    },

    onChangeMrcSelect: (model, value) => (dispatch, state) => {
        const { MrcRechargeAmountString, DummyLineItemAmountString, DummyInvoiceDate,
            DummyInvoiceDueDate } = state()?.rechargeInventoryDetails?.rechargeInventoryData?.data ?? {};

        if (model === "rechargeInventoryDetailsForm.mrcInformation.mrcRecharge") {
            dispatch(actions.change('rechargeInventoryDetailsForm.mrcInformation.mrcRecharge', value));
            if (value === "false") {
               dispatch(actions.reset('rechargeInventoryDetailsForm.mrcInformation.mrcRechargeAmount'));
            } else {
                dispatch(actions.load('rechargeInventoryDetailsForm.mrcInformation.mrcRechargeAmount', MrcRechargeAmountString))
            }
        }
        else {
            dispatch(actions.change('rechargeInventoryDetailsForm.mrcInformation.rechargeViaDummyInvoice', value));
            if (value === "false") {
                dispatch(actions.reset('rechargeInventoryDetailsForm.mrcInformation.dummyLineItemAmount'));
                dispatch(actions.reset('rechargeInventoryDetailsForm.mrcInformation.dummyInvoiceDate'));
                dispatch(actions.reset('rechargeInventoryDetailsForm.mrcInformation.dummyInvoiceDueDate'));
            }
            else {
                dispatch(actions.load('rechargeInventoryDetailsForm.mrcInformation.dummyLineItemAmount', DummyLineItemAmountString));
                dispatch(actions.load('rechargeInventoryDetailsForm.mrcInformation.dummyInvoiceDate', DummyInvoiceDate ? convertDateStringToDateFormat(DummyInvoiceDate, false) : null));
                dispatch(actions.load('rechargeInventoryDetailsForm.mrcInformation.dummyInvoiceDueDate', DummyInvoiceDueDate ? convertDateStringToDateFormat(DummyInvoiceDueDate, false) : null));
            }
        }
    }

    
};

async function getRechargingEmployees(pageIndex, searchString, dispatch) {
    const pageSize = 15;

    dispatch({
        type: setRechargingEmployeeLoading
        , payload: true
    })

    try {
        let url = `external/recharge/getRechargingEmployee/${pageIndex}/${pageSize}`;
        if (searchString) {
            url += `/${encodeURIComponent(searchString)}`;
        }
        var res = await httpGet(url);

        if (res !== null) {
            return {
                employeeData: res
            }
        }
    }
    catch (error) {
        return null;
    }
    finally {
        dispatch({
            type: setRechargingEmployeeLoading
            , payload: false
        })
    }
}

export const reducer = (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case getRechargeInventoryDropdownList:
            return {
                ...state,
                isRechargeInventoryDropDownListLoaded: action.isRechargeInventoryDropDownListLoaded,
                rechargeInventoryDetailsDropDownList: action.rechargeInventoryDetailsDropDownList
            };
        case getMrcRechargeDropdown:
            return {
                ...state,
                mrcRechargeDropdown: action.mrcRechargeDropdown
            };
        case getRechargeViaDummyInvoiceDropdown:
            return {
                ...state,
                rechargeViaDummyInvoiceDropdown: action.rechargeViaDummyInvoiceDropdown
            };
        case getRechargeInventoryDetails:
            return {
                ...state,
                fetchRechargeInventoryDetails: action.data.fetching,
                rechargeInventoryData: action.data
            };
        case getMappingInformationList:
            return{
                ...state,
                mappingInformationList:{
                    datatable: action.datatable,
                },
            };
        case addMappingInformation:
            return {
                ...state,
                mappingInformationList: {
                ...state.mappingInformationList,
                datatable: action.datatable
                }
            };
        case updateMappingInformation:
            return {
                ...state,
                mappingInformationList: {
                ...state.mappingInformationList,
                datatable: action.datatable
                }
            };
        case deleteMappingInformation:
            return {
                ...state,
                mappingInformationList: {
                    ...state.mappingInformationList,
                    datatable: action.datatable
                }
            };

       case getRechargeInventoryComments:
        return {
            ...state,
            rechargeComments: [...state.rechargeComments, ...action.rechargeComments],
            hasMoreRechargeComments: action.hasMoreData,
            pageCommentsIndex: action.pageIndex
        };

        case getRechargeInventoryLineItems:
        return {
            ...state,
            rechargeLineItems: action.rechargeLineItems,
            isRechargeLineItemLoaded: true
        };
        case setRechargeLineItemsColSearchStr:
            return {
                ...state,
                rechargeLineItems: action.data,
                isRechargeLineItemLoaded: action.isRechargeLineItemLoaded,
        }
        case setRechargeLineItemsPageSize:
                    return {
                        ...state,
                        rechargeLineItems: {
                            ...state.rechargeLineItems,
                            Pagination: {
                                ...state.rechargeLineItems.Pagination,
                                PerPage: action.pageSize
                            }
                        }
                    }
        case setSortRechargeLineItems:
            return {
                ...state,
                rechargeLineItems: action.rechargeLineItems,
                isRechargeLineItemLoaded: true
            };
        case setResetRechargeLineItems:
            return {
                ...state,
                rechargeLineItems: [],
                isRechargeLineItemLoaded: false

            };
        case setRequestorOptions:
            const { requestorOption, requestorPage } = action.payload;
            const newRequestor = Array.isArray(requestorOption) ? requestorOption : [];
            return {
                ...state,
                requestorOptions: requestorPage === 1
                   ? newRequestor 
                    : [...state.requestorOptions, ...newRequestor]
                , requestorPage: requestorPage
                , hasMoreRequestor: newRequestor.length > 0
            }
        case setEndUserOptions:
            const { endUserOption, endUserpage } = action.payload;
            const newEndUser = Array.isArray(endUserOption) ? endUserOption : [];
            return {
                ...state,
                endUserOptions: endUserpage === 1
                    ? newEndUser
                    : [...state.endUserOptions, ...newEndUser]
                , endUserPage: endUserpage
                , hasMoreEndUser: newEndUser.length > 0
            }
        case setRechargingPersonOptions:
            const { rechargingPersonOption, rechargingPersonpage } = action.payload;
            const newRechargingPerson = Array.isArray(rechargingPersonOption) ? rechargingPersonOption : [];
            return {
                ...state,
                rechargingPersonOptions: rechargingPersonpage === 1
                    ? newRechargingPerson
                    : [...state.rechargingPersonOptions, ...newRechargingPerson]
                , rechargingPersonPage: rechargingPersonpage
                , hasMoreRechargingPerson: newRechargingPerson.length > 0
            }
        case setRechargingEmployeeLoading:
            return {
                ...state,
                isEmployeeLoading: action.payload
            };
        case setVendorOption:
            const { vendorOption, vendorPage } = action;
            const newVendor = Array.isArray(vendorOption) ? vendorOption : [];
            return {
                ...state,
                vendorOptions: vendorPage === 1
                    ? newVendor
                    : [...state.vendorOptions, ...newVendor]
                , vendorPage: vendorPage
                , hasMoreVendor: newVendor.length > 0
            }
        case setVendorLoading:
            return {
                ...state,
                isVendorLoading: action.payload
            };
        case setLocationOption:
            const { locationOption, locationPage } = action;
            const newLocation = Array.isArray(locationOption) ? locationOption : [];
            return {
                ...state,
                locationOptions: locationPage === 1
                    ? newLocation
                    : [...state.locationOptions, ...newLocation]
                , locationPage: locationPage
                , hasMoreLocation: newLocation.length > 0
            }
        case setLocationLoading:
            return {
                ...state,
                isLocationLoading: action.payload
            };
        case setCircuitOption:
            const { circuitOption, circuitPage } = action;
            const newCircuit = Array.isArray(circuitOption) ? circuitOption : [];
            return {
                ...state,
                circuitOptions: circuitPage === 1
                    ? newCircuit
                    : [...state.circuitOptions, ...newCircuit]
                , circuitPage: circuitPage
                , hasMoreCircuit: newCircuit.length > 0
            }
        case setCircuitLoading:
            return {
                ...state,
                isCircuitLoading: action.payload
            };
        case getCostCodeList:
            return {
                ...state,
                rechargeCostCode: action.page === 1? action.rechargeCostCode ?? [] : [...state.rechargeCostCode, ...action.rechargeCostCode ?? []],
                hasMoreCostCode: action.hasMoreData,
                isCostCodeListLoaded: action.isCostCodeListLoaded,
                costCodePage: action.page
            }
        case resetCostCodeList:
            return{
                ...state,
                rechargeCostCode: [],
                costCodePage: 1,
                isCostCodeListLoaded: false
            }
        case insertToRechargeComment: {
            const combinedComments = [
                ...action.rechargeComments,
                ...state.rechargeComments
            ];

            const currentVisibleCount = state.rechargeComments.length;
            const currentDisplayLimit = Math.ceil(currentVisibleCount / 5) * 5;
            const hasMore = combinedComments.length > currentDisplayLimit && combinedComments.length !== 1;

            let updatedComments;
            if (hasMore) {
                updatedComments = combinedComments.slice(0, -1);
            } else {
                updatedComments = combinedComments;
            }

            return {
                ...state,
                rechargeComments: combinedComments.length === 1 ? action.rechargeComments : updatedComments,
                hasMoreRechargeComments: hasMore, // renamed for clarity & consistency
            };
        }
        case resetRechargeComments:
        return {
            ...state,
            rechargeComments: [],
            hasMoreRechargeComments: false,
            pageCommentsIndex: 1
        };

        default:
            return state;
    }
};